import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

import { AutoComplete } from 'primeng/autocomplete';

import { Observable, Subject, takeUntil } from 'rxjs';

import { ApiNamedListItem } from 'sc-common';

@Component({
    selector: 'et-header-autocomplete',
    templateUrl: './header-autocomplete.component.html',
    standalone: false
})
export class HeaderAutocompleteComponent implements OnDestroy {

    @Input()
    public placeholder: string;

    @Input()
    public queryExpression: (query: string, excludedIds: number[]) => Observable<ApiNamedListItem[]>;

    @Input()
    public addAction: (ids: number[]) => Observable<void>;

    @Output()
    public readonly itemsAdded = new EventEmitter<void>();

    @ViewChild('autocomplete', { static: true })
    private readonly _autocomplete: AutoComplete;

    public suggestions: ApiNamedListItem[];

    public requestInProcess: boolean;

    public get buttonsVisible(): boolean {
        return this._autocomplete.value?.length;
    }

    private readonly _destroy$ = new Subject<void>();

    public ngOnDestroy(): void {

        this._destroy$.next();
        this._destroy$.complete();
    }

    public filterItems(event: { query: string; originalEvent: any; }): void {

        if (!event.query) {
            return;
        }

        const selectedIds = this._autocomplete.value?.map((i: ApiNamedListItem) => i.id);

        this.queryExpression(event.query, selectedIds)
            .pipe(takeUntil(this._destroy$))
            .subscribe(data => this.suggestions = data);
    }

    public clearAutocomplete(): void {
        this._autocomplete.writeValue([]);
    }

    public addItems(): void {
        this.requestInProcess = true;

        this.addAction(this._autocomplete.value?.map((i: ApiNamedListItem) => i.id))
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                this._autocomplete.writeValue([]);
                this.requestInProcess = false;

                this.itemsAdded.emit();
            });
    }
}
